import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  GetLocationsQuery,
  GetLocationsResponse,
  LocationsAPI,
} from "./locations.api";

const locationsQueryKeys = {
  list: (query?: GetLocationsQuery) => ["locations", "list", query],
  infiniteList: (query?: GetLocationsQuery) => [
    "locations",
    "infinite-list",
    query,
  ],
  details: (id: number) => ["locations", "list", { id }],
};

const useGetLocations = (
  query?: GetLocationsQuery,
  options?: Omit<
    UseQueryOptions<GetLocationsResponse, Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: locationsQueryKeys.list(query),
    queryFn: () => LocationsAPI.get(query),
    ...options,
  });
};

export const LocationsQuery = {
  queryKeys: locationsQueryKeys,
  useGetLocations,
};
